import { Component } from '@angular/core';

@Component({
  templateUrl: 'changeagent.component.html'
})
export class ChangeagentComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/agencies/changeagent.component.ts